import { render } from "./PublicQuestionChipComponent.vue?vue&type=template&id=2d5253a5&scoped=true"
import script from "./PublicQuestionChipComponent.vue?vue&type=script&lang=js"
export * from "./PublicQuestionChipComponent.vue?vue&type=script&lang=js"

import "./PublicQuestionChipComponent.vue?vue&type=style&index=0&id=2d5253a5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d5253a5"]])

export default __exports__